<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <regime-federal v-model="value" :isNovo="isNovo" :ativo="value.ativo" />
        <!-- </div>
      <div class="col-sm-12"> -->
        <regime-estadual v-model="value" :isNovo="isNovo" :ativo="value.ativo" />
      </div>
    </div>
  </div>
</template>

<script>
import RegimeFederal from './RegimeFederal.vue'
import RegimeEstadual from './RegimeEstadual.vue'

export default {
  name: 'empresa-regimes',
  props: {
    value: {},
    isNovo: {
      type: Boolean,
      required: true
    },
    disableAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // empresa: new Empresa()
    }
  },
  mounted() {
    // this.empresa = this.value
    if (this.disableAll) {
      Array.from(this.$children).map(x => {
        Array.from(x.$el.querySelectorAll('input')).map(x => {
          x.disabled = true
        })
      })
    }
  },
  components: {
    RegimeFederal,
    RegimeEstadual
  }
}
</script>

<style lang="css" scoped></style>
